<template>
    <div class="tabHead">
        <div class="task-info">
            <div class="task-info-title">任务信息</div>
            <el-button v-has="'otp04040014'" v-if="isShipment" class="shipment" type="primary" @click="shipmentShowOk">装货确认</el-button>
            <el-button v-if="wtTypeFlag" class="shipment" type="primary" @click="shipmentShowOk">结束装车</el-button>
        </div>
        <template>
                <el-table :data="tableDatas" border @cell-dblclick="celldblclick" class="tabContentList" max-height="250">
                <el-table-column prop="custOrderNo" label="客户订单号" width="120" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ scope.row.custOrderNo }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="taskNo" label="运输单号" width="160" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="wlLoadSequence" label="装车排序" width="160" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="contractNo" label="合同号" :show-overflow-tooltip="true" width="160"></el-table-column>
                <el-table-column prop="whName" label="仓库" :show-overflow-tooltip="true" width="120"></el-table-column>
                <el-table-column prop="customerName" label="客户" :show-overflow-tooltip="true" width="180"></el-table-column>
                <el-table-column prop="itemName" label="商品名称" width="320" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="scope.row.editing !== 'save' || !scope.row.planOrderFlag">
                            <span>{{scope.row.itemName}}</span>
                        </div>
                        <div v-else class="textInput">
                            <otpAdvance
                                ref="itemNameAdvance"
                                @getAdvanceValue="getAdvanceValue($event, scope.$index, scope.row)"
                                :mValue="scope.row.itemName"
                                :params="itemName"
                            ></otpAdvance>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="customerItemCode" label="客户商品编码" width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="itemCode" label="商品编码" width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="rfActLoadQty" label="实扫数量" width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="planQty" label="数量" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.editing !== 'save' || !scope.row.planOrderFlag">
                            <span>{{scope.row.planQty}}</span>
                        </div>
                        <div v-else class='textInput'>
                            <el-input v-model.trim="scope.row.planQty"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="actQty" label="实发数量">
                    <template slot-scope="scope">
                        <div v-if="scope.row.editing !== 'save'">
                            <span>{{ scope.row.actQty }}</span>
                        </div>
                        <div v-else class='textInput'>
                            <el-input v-model.trim="scope.row.actQty" @input="actQtyChange(scope.row)"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="planVolume" label="方量(m³)" width="80">
                    <template slot-scope="scope">
                        {{scope.row.planQty*scope.row.volume? Math.round(scope.row.planQty*scope.row.volume * 1000000) / 1000000 : 0}}
                    </template>
                </el-table-column>
                <el-table-column prop="actVolume" label="实发方量(m³)" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.editing !== 'save' || !scope.row.planOrderFlag || scope.row.actQty <=0 ||scope.row.volume">
                            <span> {{scope.row.actQty*scope.row.volume ? Math.round(scope.row.actQty*scope.row.volume * 1000000) / 1000000 : 0 }}</span>
                        </div>
                        <div v-else class='textInput'>
                            <el-input v-model.trim="scope.row.actVolume"></el-input>
                        </div>
                    </template>
                </el-table-column>
                 <el-table-column prop="planGrossWeight" label="重量(Kg)" width="80">
                    <template slot-scope="scope">{{scope.row.planQty*scope.row.grossWeight?Math.round(scope.row.planQty*scope.row.grossWeight * 1000000) / 1000000 : 0}}</template>
                </el-table-column>
                 <el-table-column prop="actGrossWeight" label="实发重量(Kg)" width="100">
                    <template slot-scope="scope">
                        <div
                            v-if="
                                scope.row.editing !== 'save' ||
                                !scope.row.planOrderFlag ||
                                scope.row.actQty <= 0 ||
                                scope.row.grossWeight
                            "
                        >
                            <span>
                                {{
                                    scope.row.actQty * scope.row.grossWeight
                                        ? Math.round(
                                              scope.row.actQty *
                                                  scope.row.grossWeight *
                                                  1000000
                                          ) / 1000000
                                        : 0
                                }}</span
                            >
                        </div>
                        <div v-else class='textInput'>
                            <el-input v-model.trim="scope.row.actGrossWeight"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="senderDetailAddr" label="发货地址" width="80" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="receiverName" label="收货人" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.editing !== 'save' || !scope.row.planOrderFlag">
                            <span>{{scope.row.receiverName}}</span>
                        </div>
                        <div v-else class='textInput'>
                            <el-input v-model.trim="scope.row.receiverName"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="receiverAddrName" label="收货四级地址" width="300" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="scope.row.editing !== 'save' || !scope.row.planOrderFlag">
                            <span>{{scope.row.receiverProvinceName}} / {{scope.row.receiverCityName}} / {{scope.row.receiverDistrictName}} / {{scope.row.receiverTownName}}</span>
                        </div>
                        <div v-else class='textInput'>
                            <otpAllAddressSelect
                                :minLayers="4"
                                v-model="scope.row.receiverAddr"
                                @getAddress="getAddress($event, scope.row)"
                            ></otpAllAddressSelect>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="receiverDetailAddr" label="收货详细地址" width="200">
                    <template slot-scope="scope">
                        <div v-if="scope.row.editing !== 'save' || !scope.row.planOrderFlag">
                            <span>{{scope.row.receiverDetailAddr}}</span>
                        </div>
                        <div v-else class='textInput'>
                            <el-input v-model.trim="scope.row.receiverDetailAddr"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="upperReceiverName" label="收货单位" width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="taskStatusName" label="运输单状态" width="100">
                    <template slot-scope="scope"><span :class="scope.row.statusActive ? 'status-active' : ''">{{scope.row.taskStatusName}}</span></template>
                </el-table-column>
                <el-table-column prop="businessTypeName" label="计费业务类型" :show-overflow-tooltip="true"  width="100"></el-table-column>
                <el-table-column prop="invoiceUnitCode" label="会计主体编码" :show-overflow-tooltip="true"  width="100"></el-table-column>
                <el-table-column prop="invoiceUnitName" label="会计主体名称" :show-overflow-tooltip="true"  width="100"></el-table-column>
                <el-table-column prop="distributionFlagName" label="是否分拨" :show-overflow-tooltip="true"  width="100"></el-table-column>
                <el-table-column prop="distributionWhName" label="分拨仓库" :show-overflow-tooltip="true"  width="100"></el-table-column>
                <el-table-column prop="actualArriveDate" label="到车时间" :show-overflow-tooltip="true"  width="100"></el-table-column>
                <el-table-column prop="arrivalWayText" label="抵达方式" :show-overflow-tooltip="true"  width="100"></el-table-column>
                <el-table-column prop="arrivalTime" label="抵达时间" :show-overflow-tooltip="true"  width="100"></el-table-column>
                <el-table-column prop="wmsStatusName" label="WMS状态" :show-overflow-tooltip="true"  width="100"></el-table-column>
                <el-table-column prop="queueCode" label="排队编码" :show-overflow-tooltip="true"  width="160"></el-table-column>
                <el-table-column prop="supplierReserveFlagName" label="供方预约" :show-overflow-tooltip="true"  width="100"></el-table-column>
                <el-table-column prop="appointmentTime" label="预约时间" :show-overflow-tooltip="true"  width="160"></el-table-column>
                <el-table-column prop="deliveredVerifyFlagName" label="签收类型" width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="requireOutTime" label="要求发货时间" width="160" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="pickUpStatusName" label="是否已提货" width="120px" :show-overflow-tooltip="true" sortable ></el-table-column>
                <el-table-column prop="completeSetNo" label="套送号" width="120px" :show-overflow-tooltip="true" sortable ></el-table-column>
                <el-table-column fixed="right" label="操作" width="100" align="center" v-if="isOperation">
                    <template slot-scope="scope" v-if="(+scope.row.planOrderFlag && Number(scope.row.taskStatus) < 30) ||
                        (!scope.row.planOrderFlag && +scope.row.taskStatus === 20 &&
                        ['YS', 'IN'].includes(scope.row.inOutType))">
                        <span class="table-btn" v-if="scope.row.planOrderFlag">
                            <el-button type="text" @click="handleAdd(scope.$index, scope.row)"><i class="el-icon-plus"></i></el-button>
                        </span>
                        <span v-has="'otp04040011'" v-if="scope.row.editing === 'edit'" class="table-btn">
                            <el-button type="text" @click="handleEdit(scope.$index, scope.row)"><i class="el-icon-edit"></i></el-button>
                        </span>
                        <span v-has="'otp04040012'" v-else-if="scope.row.editing === 'save'" class="table-btn">
                            <el-button type="text" @click="handleSave(scope.$index, scope.row)"><i class="el-icon-check"></i></el-button>
                        </span>
                        <span class="table-btn" v-if="(!scope.row.id || scope.row.canDelete) && scope.row.planOrderFlag">
                            <el-button type="text" @click="handleDel(scope.$index, scope.row)"><i class="el-icon-minus"></i></el-button>
                        </span>
                        <span v-has="'otp04040021'" v-if="ShowReserve(scope.row)" class="table-btn">
                            <el-button type="text" @click="reserveClick(scope.row)">预约</el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
</template>
<script>
import otpAllAddressSelect from '@/components/lots/otpCascader2';
import otpAdvance from '@/components/lots/otpAdvance';
import { getHandLoadings, getConfirmations, detailDelete, confirmPlanOrder } from '../../../api/dispatchOrderDetail';
import { loadCheckElectronic } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { dictWithUrl } from '@/components/lots/api.js';
const stateListMap = new Map();
const stateListFlag = new Map();
const arriveTypeSetMap = new Map();
stateListMap.set('10', '宅配').set('5', '快递').set('4', '配送').set('3', '运输').set('2', '装卸').set('1', '仓储');
stateListFlag.set('Y', '是').set('N', '否');
arriveTypeSetMap
    .set('', '')
    .set('01', '手动抵达')
    .set('02', '直通宝抵达')
    .set('03', '自动抵达')
    .set('04', '签收触发抵达')
    .set('05', '直通宝APP抵达')
    .set('06', '直通宝微信抵达')
    .set('07', '打点触发抵达')
    .set('08', '蓝桥抵达')
    .set('09', '车满满抵达')
    .set('10', '围栏抵达')
    .set('10', '围栏抵达')
    .set('11', '直通宝审批抵达')
    .set('12', '直通宝APP抵达')
    .set('13', '直通宝微信抵达');
const PRIVILEGE_CONFIRM = 'otp04040024';
const TRANSPORT_STATUS_DISPATCH = 30; // 待发车状态
const OUT_OF_STOCK = 900; // WMS_STATUS-WMS状态-已出库

export default {
    components: { otpAllAddressSelect, otpAdvance },
    props: {
        tableData: {
            type: Array,
            default () {
                return [];
            }
        },
        process: {
            type: Object,
            default () {
                return {};
            }
        },
        resDispatchStatus: {
            type: Number,
            default: 0
        },
        wtTypeFlag: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            tableDatas: [],
            isShipment: false,
            'itemName': {
                'name': '请输入商品名称',
                'advanceLabel': '商品名称',
                'value': 'itemName',
                'advanceConfig': [
                    { 'prop': 'cdcmNameCn', 'value': '商品名称' },
                    { 'prop': 'cdcmCustMaterialNo', 'value': '客户商品编码' },
                    { 'prop': 'cdcmMaterialNo', 'value': '商品编码' }
                ],
                'tableConfig': [
                    { 'prop': 'cdcmNameCn', 'value': '商品名称' },
                    { 'prop': 'cdcmCustMaterialNo', 'value': '客户商品编码' },
                    { 'prop': 'cdcmMaterialNo', 'value': '商品编码' }
                ],
                'advanceUrl': 'cdCommonMaterial/searchByMaterial',
                'cbParams': [
                    'cdcmNameCn#itemName', 'cdcmMaterialNo#itemCode', 'cdcmCustMaterialNo#customerItemCode',
                    'cdcmWeight#grossWeight', 'cdcmCube#volume'
                ]
            },
            canEditInitData: { itemName: '', itemCode: '', customerItemCode: '', planQty: '', actQty: '', receiverDetailAddr: '', receiverAddr: '', receiverName: '' },
            isOperation: true,
            TRANSPORT_STATUS_DISPATCH: TRANSPORT_STATUS_DISPATCH
        };
    },
    methods: {
        reserveClick (row) {
            this.$emit('reserveClick', row);
        },
        celldblclick (row, column, cell, event) {
            let clickTabContent = '';
            switch (column.property) {
            case 'planVolume':
                clickTabContent = row.planQty * row.volume ? Math.round(row.planQty * row.volume * 1000000) / 1000000 : 0;
                break;
            case 'actVolume':
                clickTabContent = row.actQty * row.volume ? Math.round(row.actQty * row.volume * 1000000) / 1000000 : 0;
                break;
            case 'planGrossWeight':
                clickTabContent = row.planQty * row.grossWeight ? Math.round(row.planQty * row.grossWeight * 1000000) / 1000000 : 0;
                break;
            case 'actGrossWeight':
                clickTabContent = row.actQty * row.grossWeight ? Math.round(row.actQty * row.grossWeight * 1000000) / 1000000 : 0;
                break;
            case 'receiverAddrName':
                clickTabContent = `${row.receiverProvinceName} / ${row.receiverCityName} / ${row.receiverDistrictName} / ${row.receiverTownName}`;
                break;
            default:
                clickTabContent = row[column.property];
            }
            if (clickTabContent === undefined) return;
            const inputEle = document.createElement('input');
            document.body.appendChild(inputEle);
            inputEle.setAttribute('value', clickTabContent);
            inputEle.setAttribute('readonly', 'readonly');
            inputEle.select();
            document.execCommand('copy');
            document.body.removeChild(inputEle);
            this.$message.success(`‘${inputEle.value}’ 复制成功`);
        },
        handleEdit ($index, row) { row.editing = 'save'; },
        handleAdd ($index, row) {
            this.tableDatas.unshift(
                { ...row, editing: 'save', ...this.canEditInitData, id: '', volume: '', grossWeight: '' }
            );
        },
        handleDel ($index, row) {
            if (!row.id) {
                this.tableDatas.splice($index, 1);
            } else {
                detailDelete({ id: row.id }).then(res => {
                    if (res) {
                        this.$message.success('删除成功');
                        this.$emit('getHandLoadingsSave');
                    }
                });
            }
        },
        getAdvanceValue (data, $index, row) {
            Object.keys(data).forEach(key => {
                this.$set(row, key, data[key]);
            });
        },
        getAddress (labels, row) {
            if (labels) {
                ['receiverProvinceName', 'receiverCityName', 'receiverDistrictName', 'receiverTownName'].forEach((key, index) => {
                    row[key] = labels[index] || '';
                });
            }
        },
        handleSave ($index, row) {
            const itemCodeList = ((this.tableDatas.filter((el, index) => index !== $index)).filter(item => item.custOrderNo === row.custOrderNo)).map(i => i.itemCode);
            if (row.planOrderFlag) {
                if (!(row.itemName && row.customerItemCode && row.itemCode)) return this.$message.warning('客户商品编码、商品信息不能为空！');
                if (itemCodeList.includes(row.itemCode)) return this.$message.warning('该客户订单号下已存在该商品，商品信息不能重复！');
            }
            if (row.receiverAddr) {
                [row.receiverProvinceCode, row.receiverCityCode, row.receiverDistrictCode, row.receiverTownCode = ''] = row.receiverAddr;
            }
            if (this.tableDatas[$index].actQty === '') {
                this.$message.warning('实发数量不能为空');
                return false;
            }
            const reg = /^[0-9]*$/;
            if (reg.test(this.tableDatas[$index].actQty) === false) {
                this.tableDatas[$index].actQty = '';
                this.$message.warning('实发数量只能输入数字且不能为小数');
                return false;
            }
            if (!reg.test(this.tableDatas[$index].planQty)) {
                this.tableDatas[$index].planQty = 0;
                return this.$message.warning('数量只能输入数字且不能为小数');
            }
            if (+this.tableDatas[$index].actQty > +this.tableDatas[$index].planQty) {
                this.$message.warning('实发数量不能大于总数量');
                this.tableDatas[$index].actQty = '';
                return false;
            }
            const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
            if (this.tableDatas[$index].actVolume && reg1.test(this.tableDatas[$index].actVolume) === false) {
                this.tableDatas[$index].actVolume = '';
                return this.$message.warning('实发方量只能输入数字');
            }
            if (this.tableDatas[$index].actGrossWeight && reg1.test(this.tableDatas[$index].actGrossWeight) === false) {
                this.tableDatas[$index].actGrossWeight = '';
                return this.$message.warning('实发重量只能输入数字');
            }
            let params = {};
            if (row.planOrderFlag) {
                params = {
                    dispatchNo: this.$route.query.dispatchNo,
                    item: [this.tableDatas[$index]],
                    planOrderFlag: this.tableDatas[$index].planOrderFlag
                };
            } else {
                params = {
                    dispatchNo: this.$route.query.dispatchNo,
                    taskNo: this.tableDatas[$index].taskNo,
                    id: row.id,
                    actQty: this.tableDatas[$index].actQty,
                    version: row.version
                };
            }
            getHandLoadings(params).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('保存成功');
                    this.tableDatas[$index].editing = 'edit';
                    this.$emit('getHandLoadingsSave');
                }
            });
        },
        shipmentShowOk () {
            let initDataNoVal = 0;
            let planOrderFlagCount = 0;
            this.tableDatas.forEach(item => {
                if (item.planOrderFlag) ++planOrderFlagCount;
                Object.keys(this.canEditInitData).forEach(key => {
                    if (!item[key] && item.planOrderFlag) ++initDataNoVal;
                });
            });
            if (initDataNoVal) return this.$message.warning('商品信息不完整！/地址信息不完整！');
            const params = { dispatchNo: this.process.orderNo };
            if (planOrderFlagCount) {
                confirmPlanOrder(params).then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('装货确认成功');
                        this.$emit('getHandLoadingsSave');
                    }
                }).catch(() => { });
            } else {
                loadCheckElectronic(params).then(res => {
                    if (res && +res.code === 0) {
                        getConfirmations(params).then(res => {
                            if (res && res.code === '0') {
                                this.$message.success('装货确认成功/结束装车成功');
                                this.$emit('getHandLoadingsSave');
                            }
                        }).catch(() => { });
                    }
                }).catch(() => { });
            }
        },
        actQtyChange (row) {
            if (!row.grossWeight && row.actGrossWeight) {
                row.actGrossWeight = '';
            }
            if (!row.volume && row.actVolume) {
                row.actVolume = '';
            }
        }
    },
    computed: {
        ShowReserve () {
            return (row) => {
                let flag = false;
                if (row.reserveFlag && this.resDispatchStatus !== 100) {
                    if (row.businessMode === 'B2C' && row.taskStatus < 70) {
                        flag = true;
                    }
                    const isTrue = row.taskStatus < 40 && !(row.deliveryType === 'NET' && row.distributionFlag === 'Y' && row.distributionNum === 1);
                    if (row.businessMode === 'B2B' && isTrue) {
                        flag = true;
                    }
                }
                return flag;
            };
        },
    },
    watch: {
        async tableData (val) {
            this.isShipment = false;
            let isOperationCount = 0;
            const taskStatusActions = {
                0: ['待调度', false],
                6: ['待调车', false],
                10: ['待到车', true],
                20: ['待装车', false],
                30: ['待发车', false],
                40: ['在途', false],
                50: ['抵达', false],
                60: ['待签收', false],
                70: ['待移交', false],
                100: ['完成', false],
                200: ['已拒收', false],
                999: ['取消', false]
            };
            const dict = await dictWithUrl('DELIVERED_VERIFY_FLAG,PICK_UP_STATUS');
            const dictData = dict.data;
            this.tableDatas = val.map(item => {
                item.supplierReserveFlagName = item.supplierReserveFlag === 'Y' ? '是' : '否';
                if (item.supplierReserveFlag === 'Y') {
                    item.reserveFlag = true;
                    ++isOperationCount;
                }
                item.receiverAddr = [item.receiverProvinceCode || '', item.receiverCityCode || '', item.receiverDistrictCode || '', item.receiverTownCode || ''];
                item.distributionFlagName = stateListFlag.get(item.distributionFlag);
                item.businessTypeName = stateListMap.get(item.businessType);
                item.arrivalWayText = arriveTypeSetMap.get(item.arrivalWay);
                if (!item.editing) this.$set(item, 'editing', 'edit');
                item.taskStatusName = taskStatusActions[item.taskStatus][0];
                item.statusActive = taskStatusActions[item.taskStatus][1];
                item.deliveredVerifyFlagName = dictData.DELIVERED_VERIFY_FLAG[item.deliveredVerifyFlag] || item.deliveredVerifyFlag;
                item.pickUpStatusName = dictData.PICK_UP_STATUS[item.pickUpStatus] || item.pickUpStatus;
                Object.keys(this.canEditInitData).forEach(key => {
                    if (!item[key] && item[key] === '') this.$set(item, key, '');
                });
                if (+item.planOrderFlag === 1) {
                    if (+item.taskStatus < 30) ++isOperationCount;
                } else {
                    if (+item.taskStatus === 20 &&  ['YS','IN'].includes(item.inOutType)) ++isOperationCount;
                }
                return item;
            });
            this.isOperation = isOperationCount;
            // 运单状态为待装车 && 出入库为运输单(YS)、入库单(IN)，显示按钮
            if (this.tableDatas.some(item => (+item.taskStatus === 20 && ['YS','IN'].includes(item.inOutType)))){
                this.isShipment = true;
            }
        }
    }
};
</script>
